import { MessagePlugin } from 'tdesign-vue-next'

type SmartMessageTheme = 'success' | 'info' | 'warning' | 'error'
type SmartMessageInput = string | Record<string, unknown>
type SmartMessageOptions = Record<string, unknown>

const messagePlugin = MessagePlugin as unknown as Record<
  SmartMessageTheme,
  (options: Record<string, unknown>) => Promise<unknown>
>

function normalizeMessage(input: SmartMessageInput, options: SmartMessageOptions = {}) {
  if (typeof input === 'string') {
    return {
      content: input,
      ...options,
    }
  }

  return {
    ...input,
    ...options,
  }
}

export function showSmartMessage(
  theme: SmartMessageTheme,
  input: SmartMessageInput,
  options: SmartMessageOptions = {},
) {
  return messagePlugin[theme](normalizeMessage(input, options))
}

export const smartMessage = {
  success(input: SmartMessageInput, options?: SmartMessageOptions) {
    return showSmartMessage('success', input, options)
  },
  info(input: SmartMessageInput, options?: SmartMessageOptions) {
    return showSmartMessage('info', input, options)
  },
  warning(input: SmartMessageInput, options?: SmartMessageOptions) {
    return showSmartMessage('warning', input, options)
  },
  error(input: SmartMessageInput, options?: SmartMessageOptions) {
    return showSmartMessage('error', input, options)
  },
}

export function useSmartMessage() {
  return smartMessage
}
